module.exports = __webpack_public_path__ + "static/media/adex-logo-txt-dark-theme.e1e5f253.svg";